export const V1_ROUTER_LIST_ALL = '/v1/router/list-all'